import React from 'react';

import LinkSVG from '../../../../../assets/svg-components/growth/link_button.svg';
import PlaySVG from '../../../../../assets/svg-components/growth/play_button.svg';
import { MEDIA } from '../../constants';
import PresentationalLink from '../presentation-link/presentation-link';
import './videos.scss';

export interface Props {
  lang: string;
}

export const VideoSection: React.FC<Props> = ({ lang }) => {
  return (
    <div className="rc-growth-section-videos">
      {MEDIA[lang].map(({ image, link, social, label, icon }) => (
        <div key={image} className="rc-video-card">
          <div className="rc-video-card__content" onClick={() => window.open(link, '_blank')}>
            <img className="rc-video-card__image" src={image} alt={image} />
            <div className="rc-video-card__hover-container">
              {icon === 'play' ? (
                <PlaySVG className="rc-video-card__hover-container__image" />
              ) : (
                <LinkSVG className="rc-video-card__hover-container__link" />
              )}
            </div>
          </div>

          <PresentationalLink href={social} label={label} />
        </div>
      ))}
    </div>
  );
};
